import {Action} from '@ngrx/store';

/**
 * All actions of the user sub-store are described here
 * An action can have an optional payload
 */
export const UPDATE_USER_INFO = '[USER] UPDATE_USER_INFO';
export const UPDATED_USER_INFO = '[USER] UPDATED_USER_INFO';

export const UPDATE_USER_LOCAL = '[USER] UPDATE_USER_LOCAL';
export const UPDATED_USER_LOCAL = '[USER] UPDATED_USER_LOCAL';

export class UpdateUserInfoAction implements Action {
  readonly type = UPDATE_USER_INFO;
}

export class UpdatedUserInfoAction implements Action {
  readonly type = UPDATED_USER_INFO;

  constructor(public payload: UserInfoDto) {
  }
}

export class UpdateUserLocalAction implements Action {
  readonly type = UPDATE_USER_LOCAL;

  constructor(public local: string) {
  }
}

export class UpdatedUserLocalAction implements Action {
  readonly type = UPDATED_USER_LOCAL;

  constructor(public local: string) {
  }
}

export type UserAction = UpdateUserInfoAction
    | UpdatedUserInfoAction
    | UpdateUserLocalAction
    | UpdatedUserLocalAction;
